import ListItem from 'LuxKit/List/ListItem'
import { useIntl } from 'react-intl'

interface Props {
  inputValue: string
}

function NoAirportsOptionListItem(props: Props) {
  const { inputValue } = props
  const intl = useIntl()

  const title = intl.formatMessage(
    {
      id: 'OQtbyLMwE1pUzc0TtJQt',
      defaultMessage: 'Sorry, we couldn’t find "{inputValue}"',
    },
    { inputValue },
  )

  const subtitle = intl.formatMessage({
    id: 'XjP_YmzzyTFWXSef1yxW',
    defaultMessage: 'Check your spelling, or try searching for a new airport.',
  })

  return <ListItem
    title={title}
    subtitle={subtitle}
  />
}

export default NoAirportsOptionListItem
